import { ApiError } from './ApiError'
import { HttpRequest, HttpResponse } from '../interfaces/http'
import { HttpStatusKind } from '../interfaces/HttpStatusKind'
import { getKindFromHttpStatusCode } from '../httpStatusCodes/getKindFromHttpStatusCode'
import { ErrorCategory } from '../interfaces/error/ErrorCategory.Enum'

// Map error code / kind to Category
const getCat = (code: number, kind: HttpStatusKind): ErrorCategory => {
  if (code === 401) return ErrorCategory.AUTHENTICATION_FAILED
  if (code === 400) return ErrorCategory.REQUEST_PROBLEM
  // other client problems:
  if (kind === HttpStatusKind.CLIENT_ERROR) return ErrorCategory.REQUEST_PROBLEM
  if (kind === HttpStatusKind.SERVER_ERROR) return ErrorCategory.SERVER_PROBLEM_FATAL
  // fallback:
  return ErrorCategory.UNKNOWN
}

/**
 * Http errors occurs when we receive an http error response from the server, i.e.
 * a http status code in the 4xx (client error) or 5xx (server error) range.
 *
 * The error `code` property will hold the http status code. Inspect it
 * to determine the error cause, e.g. 401 = Unauthorized (invalid auth
 * credentials).
 */
export class HttpError extends ApiError {
  public readonly kind: HttpStatusKind

  constructor(args: {
    code: number;
    message: string;
    httpRequest: HttpRequest;
    httpResponse: HttpResponse;
    originalError: Error;
  }) {
    const kind = getKindFromHttpStatusCode(args.code)
    const myMessage = `Http error: ${args.message} (${args.code})`
    super({
      ...args,
      message: myMessage,
      category: getCat(args.code, kind),
      excerptExtra: { code: `${args.code} (http response code)` },
    })
    Object.setPrototypeOf(this, HttpError.prototype)
    this.kind = kind
  }

  public toJSON() {
    return JSON.stringify({ ...this.getBaseJSON(), kind: this.kind })
  }
}
